export default "__VITE_ASSET__BNsMzt35__"